// Lenis smooth scroll with a guaranteed-arrival watchdog.
// Lenis duration-tweens can stall under heavy raf contention (pinned GSAP journey);
// the watchdog forces arrival if the smooth tween hasn't landed in time.
export function scrollToTarget(target, offset = 0) {
  const el = typeof target === 'string' ? document.querySelector(target) : target;
  if (!el) return;
  const lenis = window.__lenis;
  const y = typeof target === 'number' ? target : el.getBoundingClientRect().top + window.scrollY + offset;
  if (!lenis) { window.scrollTo(0, y); return; }
  lenis.scrollTo(y, { duration: 1.1 });
  setTimeout(() => {
    if (Math.abs(window.scrollY - y) > 90) lenis.scrollTo(y, { immediate: true });
  }, 1400);
}
